const sanitizeText = (s = '') => String(s).replace(/\</g, '&lt;').replace(/\>/g, '&gt;');

export default sanitizeText;
